import React from "react";

import { ICommandParameterModel } from "@formant/core/model/commandTemplate";
import { FormControl, FormItem, FormLabel, Input } from "@formant/ui-kit";

interface IStringParameterProps {
    param: ICommandParameterModel;
    onUpdate: (updates: Partial<ICommandParameterModel>) => void;
}

export const StringParameter: React.FC<IStringParameterProps> = ({
    param,
    onUpdate,
}) => {
    return (
        <div className="space-y-4">
            <FormItem>
                <FormLabel>Default Value</FormLabel>
                <FormControl>
                    <Input
                        type="text"
                        value={String(param.value)}
                        onChange={e => onUpdate({ value: e.target.value })}
                        placeholder="Default value"
                    />
                </FormControl>
            </FormItem>
        </div>
    );
};
